function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TableauDashboardService from '@/apps/data-platform/services/visualization/tbl_dashboard_service';
import { textsDefaul, envConfig, ACCESS_TYPE_FLOW } from '@/js/constants';
import utils from '@/js/utils';
import SearchTableau from '@/components/SearchTableau';
import PaginationTableau from '@/components/PaginationTableau';
import FormMetaDashboard from '@/components/tableau/FormMetaDashboard';
import DialogsComponent from '@/components/DialogsComponent.vue';
import PaginationVue from '@/components/PaginationVue.vue';
import StateComponent from '@/components/StateComponent.vue';
import { Tableau } from '@/mixins/tableau';
import tasks from '@/js/tasks';
import FormAssignTemporalOwner from '@/components/FormAssignTemporalOwner.vue';
export default {
  name: 'ContMyDashboardsComponent',
  mixins: [Tableau],
  components: {
    SearchTableau: SearchTableau,
    FormMetaDashboard: FormMetaDashboard,
    PaginationTableau: PaginationTableau,
    DialogsComponent: DialogsComponent,
    PaginationVue: PaginationVue,
    StateComponent: StateComponent,
    FormAssignTemporalOwner: FormAssignTemporalOwner
  },
  data: function data() {
    return {
      collapse_filter: false,
      isBusy: false,
      messageLoading: textsDefaul.LOADING,
      messageEmptyList: textsDefaul.NOT_WORKBOOKS,
      defaultDomain3: null,
      title_modal: '',
      limit: envConfig.pagintaionSize,
      typeSearch: 'workbook',
      tableau_workbook: null,
      messageEmptyTableauWb: textsDefaul.LOADING,
      totalRowsWb: 0,
      pageWb: 1,
      data_wb: null,
      isReadonly: false,
      ACCESS_TYPE_FLOW: ACCESS_TYPE_FLOW,
      MODAL_NAME_OWNER: 'ContDashboardMeOwner',
      MODAL_NAME_ALL_OWNER: 'ContDashboardMeOwnerAll',
      MODAL_CHANGE_METADATA_WORKBOOK: 'modalChangeMetaWorkBook',
      pagination: {
        current: 1,
        total: 0,
        limit: 10
      },
      filter: '',
      select_domain: ''
    };
  },
  props: {
    showDomains: {
      type: Boolean,
      required: false,
      default: true
    },
    filter_enabled: {
      type: Boolean
    }
  },
  computed: {
    workBookFields: function workBookFields() {
      return [
      //{ key: '↕', variant: 'return-sort', class: 'w-3' },
      {
        text: this.traductor('my_objects.tablas_objects.dashboard'),
        value: 'object_name',
        sortable: true,
        class: 'text-left w-30'
      }, {
        text: this.traductor('my_objects.tablas_objects.environment'),
        value: 'environment',
        class: 'w-10',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_objects.tablas_objects.columns'),
        value: 'columns.length',
        class: 'w-10',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_objects.tablas_objects.views'),
        value: 'total_views',
        class: 'w-7',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_objects.tablas_objects.creation_date'),
        value: 'creation_date',
        class: 'w-15',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_objects.tablas_objects.actions'),
        value: 'actions',
        class: 'text-left w-15',
        align: 'left'
      }, {
        text: this.traductor('my_objects.tablas_objects.rol'),
        value: 'rol',
        class: 'w-10',
        align: 'center'
      }];
    },
    isEmptyWorkWb: function isEmptyWorkWb() {
      return !(this.tableau_workbook && this.tableau_workbook.length);
    },
    composeName: function composeName() {
      return function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var text = '';
        if (item) {
          text = "".concat(item.path_name, "/").concat(item.object_name).replace(/\//g, '&nbsp;/&nbsp;');
        }
        return text;
      };
    },
    isDataOperator: function isDataOperator() {
      return function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        return item.data_operator === window.userInfo.email;
      };
    },
    total_datasources: function total_datasources() {
      return function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var total = 0;
        if (item && item.columns && item.columns.length) {
          total = new Set(item.columns.map(function (column) {
            return column.datasource_id;
          })).size;
        }
        return total;
      };
    },
    hideAssignAllTables: function hideAssignAllTables() {
      var _this = this;
      return function () {
        var list_env = [];
        var data = {};
        if (_this.tableau_workbook && _this.tableau_workbook.length) {
          var _iterator = _createForOfIteratorHelper(_this.tableau_workbook),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var table = _step.value;
              data = {
                env: table.environment,
                operator: table.data_operator
              };
              list_env.push(data);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
        return list_env.some(function (item) {
          return item.env === 'prod' && item.operator === window.userInfo.email;
        });
      };
    }
  },
  created: function created() {
    if (window.userInfo.isSignIn) {
      window.userInfo.isSignIn = false;
      setTimeout(function () {
        location.reload();
      }, 1000);
    }
    this.select_domain = window.userInfo.domain;
    if (window.userInfo.isSignIn === undefined) {
      this.reloadTableauWorkBook();
    }
  },
  methods: {
    onSearch: function onSearch(filter) {
      this.filter = filter.text_filter;
      if (this.select_domain != filter.choose_domain) {
        this.select_domain = filter.choose_domain;
        this.reloadTableauWorkBook();
      }
    },
    onCleanSearch: function onCleanSearch() {
      this.filter = "";
      this.select_domain = window.userInfo.domain;
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onSearchQueryWorkBook: function onSearchQueryWorkBook(data) {
      this.reloadTableauWorkBook(data);
    },
    processParams3: function processParams3(params) {
      return _objectSpread({
        domain: this.select_domain,
        limit: this.limit,
        page: this.pageWb,
        filters: [{
          key: 'data_operator',
          operator: '==',
          value: window.userInfo.email
        }]
      }, params);
    },
    reloadTableauWorkBook: function reloadTableauWorkBook(params) {
      var _this2 = this;
      this.tableau_workbook = [];
      this.totalRowsWb = 0;
      var defaultParams = this.processParams3(params);
      this.isBusy = true;
      TableauDashboardService.tableauWorkBookQuery(defaultParams).then(function (res) {
        if (res && res.code === 200) {
          _this2.tableau_workbook = res.data.result;
          _this2.pagination.total = _this2.tableau_workbook.length;
          _this2.totalRowsWb = res.data.total;
          _this2.pageWb = res.data.page;
          _this2.messageEmptyTableauWb = res.data.result.length === 0 ? textsDefaul.NOT_WORKBOOKS : null;
        } else if (res && res.code === 400) {
          console.info(res);
        }
      }).catch(function (e) {
        utils.printError(e);
      }).finally(function () {
        _this2.isBusy = false;
      });
    },
    changeMetaWorkBook: function changeMetaWorkBook(item) {
      var _this3 = this;
      var isReadonly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var requestData = {
        domain: window.userInfo.domain,
        clauses: {
          document_id: item.id
        }
      };
      TableauDashboardService.tableauWorkBookQuery(requestData).then(function (req) {
        if (req.code === 200 && req.success) {
          _this3.data_wb = req.data.result;
          _this3.isReadonly = isReadonly;
          //this.$bvModal.show(this.MODAL_CHANGE_METADATA_WORKBOOK)
          _this3.$refs[_this3.MODAL_CHANGE_METADATA_WORKBOOK].onOpen();
        }
      });
    },
    onPageWorkBook: function onPageWorkBook(page) {
      this.pageWb = page;
      this.reloadTableauWorkBook({
        page: page
      });
    },
    onCloseModalworkBook: function onCloseModalworkBook() {
      //this.$bvModal.hide(this.MODAL_CHANGE_METADATA_WORKBOOK)
      this.$refs[this.MODAL_CHANGE_METADATA_WORKBOOK].onClose();
    },
    openAllTempOwner: function openAllTempOwner() {
      //this.$bvModal.show(this.MODAL_NAME_ALL_OWNER)
      if (!this.hideAssignAllTables()) {
        tasks.toast.error("No tiene Dashboards para asignar.");
        return;
      }
      this.$refs[this.MODAL_NAME_ALL_OWNER].onOpen();
      return true;
    },
    openTempOwner: function openTempOwner(item) {
      this.data_wb = item;
      //this.$bvModal.show(this.MODAL_NAME_OWNER)
      this.$refs[this.MODAL_NAME_OWNER].onOpen();
      return true;
    },
    assignOwner: function assignOwner() {
      //this.$bvModal.hide(this.MODAL_NAME_OWNER)
      this.$refs[this.MODAL_NAME_OWNER].onClose();
      this.reloadTableauWorkBook();
      return true;
    },
    assignAllOwner: function assignAllOwner() {
      //this.$bvModal.hide(this.MODAL_NAME_ALL_OWNER)
      this.$refs[this.MODAL_NAME_ALL_OWNER].onClose();
      this.reloadTableauWorkBook();
      return true;
    }
  }
};